import type { ShopResponse } from "@b2bportal/ground-api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import type { CarsState } from "~core-cars/store";
import { carsApi } from "~core-cars/utilities";

export const fetchCarsShop = createAsyncThunk<
  ShopResponse,
  { opaqueShopRequestContext: string; opaqueShopRequestVehicle: string },
  { state: CarsState; rejectValue: { error: string } }
>(
  "carsShop/fetchCarsShop",
  async ({ opaqueShopRequestContext, opaqueShopRequestVehicle }, thunkAPI) => {
    try {
      const res = await carsApi.apiV1GroundShopPost({
        opaqueShopRequestContext,
        opaqueShopRequestVehicle,
      });

      return res.data;
    } catch (error) {
      // Reject the thunk with an error message
      return thunkAPI.rejectWithValue({ error: String(error) });
    }
  }
);
